import { TagDimensions } from "../types";

export const dimensionsScheme: Record<TagDimensions, { labelDimensionClassName: string }> = {
  [TagDimensions.Small]: {
    labelDimensionClassName: "h-7 py-[6px] pr-[8px] pl-[12px]",
  },
  [TagDimensions.Medium]: {
    labelDimensionClassName: "py-[6px] px-[14px] h-[32px] text-sm",
  },
  [TagDimensions.Large]: {
    labelDimensionClassName: "h-[36px] py-[6px] pr-[9px] pl-[18px]",
  },
};
